import { useMutation } from '@tanstack/react-query';
import { type AxiosError } from 'axios';

import { type CompanyEmployeeDetailsDto } from '@/api/generated/models/company-employee-details-dto';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useApiClient } from '@/api/util/useApiClient.util.ts';

type Req = {
  userId: string;
};

type Response = CompanyEmployeeDetailsDto;

type Return = {
  getUserCompanyData: (req: Req) => Promise<Response>;
  isError: boolean;
  isGetting: boolean;
};

export const useGetUserCompanyData = (): Return => {
  const { usersCompanyDataApi } = useApiClient();

  const { isError, isPending, mutateAsync } = useMutation<Response, AxiosError, Req>({
    meta: { disableSuccessAlert: true },
    mutationFn: async req => {
      const response = await usersCompanyDataApi.getUserCompanyData(req.userId);
      return response.data;
    },
    mutationKey: [QueryKeyEnum.USERS.COMPANY_DATA],
  });

  return {
    getUserCompanyData: mutateAsync,
    isError,
    isGetting: isPending,
  };
};
